import Spinner from "../../../components/Spinner";
export default function AuthorizeLoading() {
  return (
    <div className="h-full w-full absolute flex flex-col  items-center justify-center">
      <Spinner />
      <span className="text-slate-400 mt-5">Authorizing ... </span>
    </div>
  );
}
